import { useEffect, useMemo, useState } from "react";
import useFetch from "../useFetch";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import hbricon from "../otherImg/hrmwlitelogo.png";
import AudioBookListContent from "./AudioBookListContent";
import { getAudioBookLastTime, initDB, saveAudioBookTime } from "../ConfigureIndexDB";
import { useRef } from "react";
import { ConstVariables } from "../newComponents2/ConstantVariables";
import { Hbrbackarrow, HbrCancel, HbrDropdownIcon, HbrDropUpIcon, HbrExitIcon, HbrSearchIcon, HbrShareIcon } from "./Mycustomsvgicons";
import { get, ref } from "firebase/database";
import { insertAudioBookAnalytics, PurifyTextUtils } from "./GeneralClasses";
import { realTimeDB } from "../firebase";
import UseLayout from "./useLayout";

const PlayAudioBook = () => {
    const [searchAudioBook,setSearchAudioBook] = useState('');
    const [isSaved,setIssaved]=useState(false);
    const [showSearch,setShowSearch]=useState(false);
    const [showMore,setShowmore]=useState("");
    const [audioBooks,setAudioBooks]=useState([]);
    const [stream, setStream] = useState(0);
    const [shares, setshares] = useState(0);
    const [rate, setrate] = useState(0);
    const [downloads, setdownloads] = useState(0);
    const {id} = useParams();
    const audioRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const {width} = UseLayout();
    const {data: audiobook,ispending1, erroralert: singleFetchError} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/audiobooks/${id}`);
    const {data: audioInfo,ispending, erroralert: fetchAllBooksErr} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/audiobooks`);

    // const {data: audiobook, ispending1, erroralert: singleFetchError} = useFetch(`http://localhost:3500/audiobooks/${id}`);
    // const {data: audioInfo, ispending, erroralert: fetchAllBooksErr} = useFetch(`http://localhost:3500/audiobooks`);

    
    useEffect(()=>{
        async function getSingleBookAnalytics() {
          if (audiobook) {
            const bookStatsSnapshot = await get(ref(realTimeDB,`audioBookStats/${PurifyTextUtils(audiobook.title)+" - Audio book 🎧"}`));
            if (bookStatsSnapshot.exists) {
                const getstream = bookStatsSnapshot.child(ConstVariables.STREAM).val();
                const getshares = bookStatsSnapshot.child(ConstVariables.SHARES).val();
                const getrate = bookStatsSnapshot.child(ConstVariables.RATE).val();
                const getdownloads = bookStatsSnapshot.child("downloads").val();

                setStream(getstream ? getstream : 0);
                setshares(getshares ? getshares : 0);
                setrate(getrate ? getrate: 0);
                setdownloads(getdownloads ? getdownloads : 0);
            }
          }
        }
        getSingleBookAnalytics();
    },[audiobook]);


    useEffect(()=>{
        async function getBookAnalytics() {
          if (audioInfo) {
            const bookStatsSnapshot = await get(ref(realTimeDB,"audioBookStats"));
            const bookStatsData = bookStatsSnapshot.val();
    
            const arrayOfBooks = Object.keys(audioInfo).map((key)=>({
              id: key,
    
              ...audioInfo[key],
    
              stream: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.stream ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].stream : 0,
    
              shares: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.shares ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].shares : 0,
    
              downloads: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.downloads ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+ " - Audio book 🎧"].downloads : 0,
    
              rate: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.rate ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].rate : 0
            }));
      
            const sortedBooks = arrayOfBooks?.sort((a,b) => b.stream - a.stream);
            setAudioBooks(sortedBooks);
          }
        }
        getBookAnalytics();
    },[audioInfo]);

    const memoizedAudioBooks = useMemo(()=>audioBooks, [audioBooks]);

    const saveCurrentAudioTime=async()=>{
        try {
            await initDB();
            const res = await saveAudioBookTime({
                id: `hab ${audiobook && audiobook._id}`,
                audioLastTime: audiobook && audioRef.current.currentTime
            });
            if(res === true){
                setIssaved(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(()=>{
        initDB().then(()=>{
            getAudioBookLastTime(`hab ${audiobook && audiobook._id}`)
            .then((data)=>{
                if(data){
                    const timeid = setTimeout(() => {
                        try{
                            audioRef.current.currentTime = data.audioLastTime
                        }catch{

                        }
                    }, 2000);
                    return () => clearTimeout(timeid);
                }
            }).catch((err)=>{
                console.log(err);
            })
        }).catch((err)=>{
            console.log(err);
        })
    },[audiobook]);

    
    const shareAudioBook=async()=>{
        if(navigator.share && audiobook){
            try{
                insertAudioBookAnalytics(audiobook.title, ConstVariables.SHARES, 0);
                await navigator.share({
                    title: `${audiobook.title}`,
                    text: `Listen to this audio book and your life will never be the same. Very inspiring and crucial for our eternal life.`,
                    url: `${ConstVariables.APP_BASE_URL}/hrmwaudiobook/${audiobook.title}/${audiobook._id}`,
                });
            }catch{
               
            }
        }else{
            
        }
    };

    const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };


    return (  
        <div className="playaudiobook">
                {singleFetchError && <div style={{
                    position:"absolute",
                    left:"50%",
                    top:"20%"
                    }}>{singleFetchError}</div>}

                {ispending1 &&
                <div style={{
                    position:"absolute",
                    left:"50%",
                    top:"20%",
                    zIndex:"1"
                    }}> 
                <CircularProgress/> <br/>
                loading...
                </div>
                }

            <div className="search-field-audiobooks">
                <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"black"} handleClick={() => handleClosePage()}/>
                <h4> Audio Bks <span style={{color:"orangered"}}>{audioInfo && audioInfo.length}</span></h4>
                <input type="search" placeholder="search for audio book by name" onChange={e => setSearchAudioBook(e.target.value)}/> 
        
                <div className="pagetoplogo flex-row2">
                    <h4 style={{color:"teal"}}>hbr<span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                    <img src={hbricon} alt=""/>
                </div>
          </div> 


          <div className="search-field-phone" style={{width:"100%", flexWrap:"wrap"}}>
                  {showSearch ?
                  <div className="flex-row2" style={{width:"100%"}}>
                    <input type="search" placeholder="search" onChange={e => setSearchAudioBook(e.target.value)}/> 
                    <HbrCancel width={"1.6em"} height={"1.6em"} fillColour={"black"} handleClick={()=>setShowSearch(false)}/>
                  </div> 
                  :
                  <HbrSearchIcon width={"1.6em"} height={"1.6em"} fillColour={"black"} handleClick={()=>setShowSearch(true)}/>
                  }

                <div className="showmorecontent" onClick={()=>setShowmore(prev => !prev)}>
                    <h4>More</h4>
                    {!showMore ? (<HbrDropdownIcon width={"1.6em"} height={"1.6em"} fillColour={"black"}/>) 
                        : (<HbrDropUpIcon width={"1.6em"} height={"1.6em"} fillColour={"black"}/>)
                    }
                   
                    {showMore && 
                        <div className="audiobookdatacomp2" >
            
                            {memoizedAudioBooks && memoizedAudioBooks.filter((audioInfo)=>{
                            if(searchAudioBook === ""){
                            return true;
                            }else if(audioInfo.title.toLowerCase().includes(searchAudioBook.toLowerCase())){
                                return true;
                            }
                            return false;
            
                            }).map((audioInfo) => (
                                <AudioBookListContent
                                key={audioInfo._id}
                                audiobookTitle={audioInfo.title}
                                audioBookImage={audioInfo.image}
                                audiobookID={audioInfo._id}
                                stream={audioInfo.stream}
                                rate={audioInfo.rate}
                                downloads={audioInfo.downloads}
                                shares={audioInfo.shares}
                            />
                            ))}
                        </div>
                    }
                </div>
                 
                  {!showSearch && 
                     <div className="pagetoplogo flex-row2">
                        <h4>hbr<span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                        <img src={hbricon} alt=""/>
                    </div>
                  } 
          </div>


          <div className="audiopayerviewdiv" style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <div className="audioplayerViewwrapper">
                    {
                        !ispending1 && audiobook &&
                        <div className="playerViewaudiobook">
                                <img src={audiobook.image} alt="Streaming from horemow book reader server"/>
                                <div className="flex-row2" style={{width:"100%"}}>
                                <audio src={audiobook.audio} ref={audioRef} controls controlsList="nodownload"/>
                                </div>
                            
                                <h4>Playing Now.. <span style={{color:"#f1356d"}}>{audiobook.title}</span></h4>
                            <h4>Tips... <br/>Save Current audio time before leaving. 
                                This will help you to resume the last time you left off on your next visit 
                                ...<br/> Search for your desired Audio Book in the search field. 
                            </h4>
                            <p id="clickmoremessage" style={{color:"white",fontWeight:"bold"}}>Click on more button 👆 to show more audio books</p>
                           
                           <div className="audiobookplayingstats flex-column1">
                                <h4>Stream: {stream}</h4>
                                <h4>Shares: {shares}</h4>
                                <h4>downloads: {downloads}</h4>
                                <h4>rate: {rate}</h4>
                           </div>

                            {audiobook.audio &&
                                <div className="saveaudiobooktime" >
                                        <svg
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        height="2em"
                                        width="2em">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path d="M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 011.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 01-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z" />
                                        </svg>
                                        <button onClick={()=>saveCurrentAudioTime()}>
                                            Save Audio Time
                                        </button>
                                </div>
                            }
                            
                            <div className="abplayershare">
                            <HbrShareIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>shareAudioBook()}/>
                            </div>
                        
                        </div>
                    }
               
                </div>
            </div>

            {width <= 580 && 
                <div className="exitonmobile flex-row2">
                    <HbrExitIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleClosePage()}/>
                    <h4>Exit Page</h4>
                </div>
            }
            
            <div className="audiobookdatacomp" >
                {fetchAllBooksErr && 
                    <div style={{
                        position:"absolute",
                        left:"50%",
                        top:"50%"
                        }}>{fetchAllBooksErr}
                    </div>
                }

                {ispending &&
                    <div style={{
                        position:"absolute",
                        left:"50%",
                        top:"50%"
                        }}> 
                    <CircularProgress/> <br/>
                    loading...
                    </div>
                } 

                {memoizedAudioBooks && memoizedAudioBooks.filter((audioInfo)=>{
                if(searchAudioBook === ""){
                return true;
                }else if(audioInfo.title.toLowerCase().includes(searchAudioBook.toLowerCase())){
                    return true;
                }
                return false;

                }).map((audioInfo) => (
                    <AudioBookListContent
                    key={audioInfo._id}
                    audiobookTitle={audioInfo.title}
                    audioBookImage={audioInfo.image}
                    audiobookID={audioInfo._id}
                    stream={audioInfo.stream}
                    rate={audioInfo.rate}
                    downloads={audioInfo.downloads}
                    shares={audioInfo.shares}
                  />
                ))}
          </div>

          {isSaved && 
            <div className="toast">
                  <p style={{color:"white",fontWeight:"bold"}}>
                   Current Time saved successfully.
                 </p> 
                 <HbrCancel width={"1.6em"} height={"1.6em"} fillColour={"white"} handleClick={()=>setIssaved(false)}/>
            </div>
            }

        </div>
    );
}
export default PlayAudioBook;